import React, { PureComponent } from "react";
import moment from "moment";
import PropTypes from "prop-types";

/**
 *
 * ArrowDatePicker:
 * - page back and forth through time with arrow icons and the date displayed.
 *
 * */
class ArrowDatePicker extends PureComponent {
  static propTypes = {
    backDisabled: PropTypes.bool,
    forwardDisabled: PropTypes.bool,
    style: PropTypes.object,
    onClick: PropTypes.func.isRequired,
    date: PropTypes.object.isRequired,
    dateFormat: PropTypes.string.isRequired,
  };

  _handleDateChange(add) {
    // TODO: add debounce function here for cases where ppl are changing dates quickly.
    let selectedDate = this.props.date;
    let m = new moment(selectedDate);
    let result;

    if (add) {
      result = new moment(m.add(1, "days"));
    } else {
      result = new moment(m.subtract(1, "days"));
    }

    this.props.onClick(result);
  }

  render() {
    return (
      <div className="date-select-line" style={this.props.style || {}}>
        <i
          className={`fas fa-arrow-left fa-pull-left
                                ${this.props.backDisabled ? "disabled" : null}
                            `}
          onClick={() => this._handleDateChange(false)}
          title="Previous Day"
        />
        <h5>{this.props.date.format(this.props.dateFormat)}</h5>
        <i
          className={`fas fa-arrow-right fa-pull-right 
                                ${
                                  this.props.forwardDisabled ? "disabled" : null
                                }`}
          title="Next Day"
          onClick={() => this._handleDateChange(true)}
        />
      </div>
    );
  }
}

export default ArrowDatePicker;
